import { CustomerReferenceTypes } from './../../../../shared/enum/customer-reference-types.enum';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import * as _ from 'lodash';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { ReferenceNumbers } from 'src/app/core/consts/reference-numbers';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ModalService } from 'src/app/shared/services/modal.service';
import { EditCustomerEntitlementsComponent } from 'src/app/components/customers/customer/supplier-release-requirements-modal/edit-customer-entitlements/edit-customer-entitlements.component'
import { SupplierReferenceTypes } from 'src/app/shared/enum/supplier-reference-types.enum';
import { RateInquiryConfirmationModalComponent } from 'src/app/components/customers/customer/supplier-release-requirements-modal/rate-inquiry-confirmation-modal/rate-inquiry-confirmation-modal.component';
import { RegexEnum } from 'src/app/core/enum/regex.enum';

@Component({
  selector: 'supplier-release-requirements-modal',
  templateUrl: './supplier-release-requirements-modal.component.html',
  styleUrls: ['./supplier-release-requirements-modal.component.scss']
})
export class SupplierReleaseRequirementsModalComponent implements OnInit {

  constructor(
    private customerService: CustomerService,
    private flashMessageService: FlashMessageService,
    private currentUserService: CurrentUserService,
    private modal: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public customerReferenceTypes = CustomerReferenceTypes;
  public supplierReferenceTypes = SupplierReferenceTypes;
  public openCustomerEntitlements: boolean = false;
  public releaseRequirements = {
    SHIP_WITH_GROUP: false,
    PICK_UP_REFERENCE_NUMBER: false,
    SHIPMENT_COST: false,
    REFERENCE_NUMBER_LOOKUP: 'CR',
    ORDER_ENTRY: false,
    EMAIL: '',
    PHONE: '',
    ORDER_ENTRY_REQUIRED_REF_NUMS: [],
    PO_RELEASE_REQUIRED_REF_NUMS: [],
    ENABLE_SUPPLIER_PORTAL: true,
    RATE_INQUIRY_TYPE: "S"
  };
  public buySell = [
    { value: "B", label: "Buy" },
    { value: "S", label: "Sell" }
  ];
  public ShipWindow = [
    { value: 'restricted', label: 'Within Ship Window' },
    { value: 'semirestricted', label: 'Up to Expiration' },
    { value: 'unrestricted', label: 'Unrestricted' }
  ];
  public refNumbs = ReferenceNumbers;
  private refFilter: any = ['CR', 'PO', 'DO', 'SI', 'SO', 'CN', 'P8'];
  public loading: boolean = false;
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public activeRole: any;
  public activeRoleDefaultEntitlements: any;
  public activeRoleCustomEntitlements: any;
  public roles: Array<any> = [];
  public customRoles;
  public activeRoleId;
  public readOnly: boolean = true;
  currentUser: string;
  public regexEnum = RegexEnum;

  ngOnInit() {
    this.loading = true;
    this._setupRef();
    this.readOnly = this.data.readOnly;

    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
    });

    this.customerService.getCustomerSupplierReleaseRequirements(this.data.customerId).then((resp: any) => {
      if (resp) {
        this.releaseRequirements = resp;
        // this page should be changed to a form group so we can add and remove new options without having to do seperate if checks
        if (!this.releaseRequirements.ORDER_ENTRY)
          this.releaseRequirements.ORDER_ENTRY = false;

        if (resp.ENABLE_SUPPLIER_PORTAL === null) {
          this.releaseRequirements.ENABLE_SUPPLIER_PORTAL = true;
        }


        if (resp.RATE_INQUIRY_TYPE === null) {
          this.releaseRequirements.RATE_INQUIRY_TYPE = "S";
        }
      }
    }).catch((error) => {
      this.loading = false;
      if (error.status === 401) {
        this.flashMessageService.updateMessage('You are not Authorized to update this customers preferences');
      } else {
        this.flashMessageService.updateMessage(error.message);
      }
    });

    let promises = [];
    promises.push(this.customerService.getRole('~HC_CUSTOMER'));
    promises.push(this.customerService.getOrganizationRoles(this.data.customerId));

    Promise.all(promises).then((data) => {
      this.roles = _.uniqBy(data[0], 'code');
      this.customRoles = data[1];
      this._enableRoles(this.customRoles);
      this.loading = false;
    }).catch(e => {
      this.loading = false;
    });
  }

  public updateSupplierReleaseRequirements() {
    this.loading = true;
    this.customerService.updateCustomerSupplierReleaseRequirements(this.releaseRequirements, this.data.customerId).then((resp) => {
      this.loading = false;
      this.flashMessageService.updateMessage('Customer preferences have been updated successfully.', 3000, "success");
    }).catch((err) => {
      this.loading = false;
      this.flashMessageService.updateMessage('There was an issue updating this customers preferences.');
    });
    this._saveCustomRoles(this.roles);
    this.modal.close();
  }

  public close() {
    this.modal.close();
  }

  public openCustomerEntitlementsModel(role, defaultEntitlements, customEntitlements) {
    this.activeRole = role;
    this.activeRoleDefaultEntitlements = defaultEntitlements;
    this.activeRoleCustomEntitlements = customEntitlements;
    this.activeRoleId = _.find(this.customRoles, ['roleCode', role]);
    if (this.activeRoleId) {
      this.activeRoleId = this.activeRoleId._id;
      let subscription = this.modal.closeEvent.subscribe((data) => {
        this.closeCustomerEntitlementsModal(data);
        subscription.unsubscribe();
      })
      this.modal.open(EditCustomerEntitlementsComponent, {
        activeRole: this.activeRole,
        roleId: this.activeRoleId,
        activeRoleCustomEntitlements: this.activeRoleCustomEntitlements,
        activeRoleDefaultEntitlements: this.activeRoleDefaultEntitlements
      })
    } else {
      this.customerService.createOrganizationRole(role, this.data.customerId).then((data) => {
        this.activeRoleId = data.data._id;
        this.customRoles.push(data.data)
        let subscription = this.modal.closeEvent.subscribe((data) => {
          this.closeCustomerEntitlementsModal(data);
          subscription.unsubscribe();
        })
        this.modal.open(EditCustomerEntitlementsComponent, {
          activeRole: this.activeRole,
          roleId: this.activeRoleId,
          activeRoleCustomEntitlements: this.activeRoleCustomEntitlements,
          activeRoleDefaultEntitlements: this.activeRoleDefaultEntitlements
        })
      });
    }
  }

  public closeCustomerEntitlementsModal(event) {
    if (event) {
      let index = _.findIndex(this.roles, ['code', event.code]);
      if (index) {
        this.roles[index].customEntitlements = event.entitlements;
      }
    }
    this.openCustomerEntitlements = false;
  }

  private _setupRef() {
    let temp = [];
    this.refNumbs.forEach(reference => {
      if (this.refFilter.includes(reference.value)) {
        temp.push(reference);
      }
    })
    this.refNumbs = temp;
  }

  private _enableRoles(roles) {
    this.roles.forEach(defaultRole => {
      defaultRole.customEntitlements = [];
      defaultRole.enabled = false;
    });
    roles.forEach((customRole) => {
      this.roles.forEach((defaultRole, i) => {
        if (customRole.roleCode == defaultRole.code) {
          defaultRole.enabled = customRole.enabled;
          defaultRole.customEntitlements = _.get(customRole, 'entitlements', []);
        }
      });
    });
  };

  private _saveCustomRoles(roles) {
    roles.forEach(role => {
      let custom = _.find(this.customRoles, ["roleCode", role.code]);
      if (custom) { // update
        this.customerService.updateOrganizationRoles(custom._id, role.enabled);
      } else { // create new
        this.customerService.createOrganizationRole(role.code, this.data.customerId, role.enabled);
      }
    });
  }

  /**
   * Check if reference number is required for Schedule Shipment
   * @param refKey reference number key
   * @returns true if its required false otherwise
   */
  public isCustRefRequired(refKey: string): boolean {
    if (!refKey ||
      !this.releaseRequirements ||
      !this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'] ||
      !this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].length) return false;

    return this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].indexOf(refKey) > -1;
  }

  /**
   * Check if reference number is required for PO Release
   * @param refKey reference number key
   * @returns true if its required false otherwise
   */
  public isSupRefRequired(refKey: string): boolean {
    if (!refKey || !this.releaseRequirements ||
      !this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'] ||
      !this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].length) return false;

    return this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].indexOf(refKey) > -1;
  }

  /**
   * Add reference numbers required for PO Release
   * @param event
   * @param refKey
   */
  public addSupRequiredRefNum(event: any, refKey: string): void {
    if (!refKey) return;

    if (event.target.checked) {
      if (!this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'] || !this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].length) {
        this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'] = [refKey]
      } else {
        this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].push(refKey);
      }
    } else {
      this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].splice(this.releaseRequirements['PO_RELEASE_REQUIRED_REF_NUMS'].indexOf(refKey), 1);
    }
  }

  /**
   * Add reference numbers required for Schedule Shipment
   * @param event click event on input element
   * @param refKey key for reference
   */
  public addCustRequiredRefNum(event: any, refKey: string): void {
    if (!refKey || !this.releaseRequirements) return;

    if (event.target.checked) {
      if (!this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'] || !this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].length) {
        this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'] = [refKey]
      } else {
        this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].push(refKey);
      }
    } else {
      this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].splice(this.releaseRequirements['ORDER_ENTRY_REQUIRED_REF_NUMS'].indexOf(refKey), 1);
    }
  }

  public alertBuyRate(option) {
    if (option === 'B') {
      let subscription = this.modal.closeEvent.subscribe((data) => {
        this.releaseRequirements['RATE_INQUIRY_TYPE'] = data;
        subscription.unsubscribe();
      })
      this.modal.open(RateInquiryConfirmationModalComponent)
    }
  }

}
